import {lifecycle} from 'recompose';

export default lifecycle({

  componentDidUpdate() {
  },

  componentWillReceiveProps(newProps) {
      if (newProps.loggedInUser && this.props.loggedInUser !== newProps.loggedInUser) {
          this.props.onSessionInitialized(newProps.loggedInUser, newProps.roles);
      }
  },

  componentDidMount() {
      if(this.props.loggedInUser) {
          this.props.onSessionInitialized(this.props.loggedInUser, this.props.roles);
      }
  }

});